import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  useTheme,
  useMediaQuery,
  Backdrop,
  LinearProgress,
  Avatar,
  IconButton,
  InputAdornment,
  Stack,
  Tooltip,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  AlertTitle,
} from "@mui/material";
import {
  InsertLink,
  Palette,
  Business,
  LocationOn,
  Phone,
  Person,
  Email,
  Message,
  CreditCard,
  Description,
  Lock,
  CloudUpload,
  Edit,
  Payment as PaymentIcon,
} from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LinkIcon from "@mui/icons-material/Link";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  createCarrier,
  createStripeConnectAccount,
  getCarrier,
  sendLogo,
} from "../../redux/action/carrier";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { setTheme } from "../../redux/reducers/themeSlice";
import { useNavigate } from "react-router-dom";
import StripeOnboarding from "../../components/stripeOnboarding/StripeOnboarding";
import PaymentReminder from "../../components/carrierPayment/CarrierPayment";

const CarrierInfo = ({ setActiveComponent }: any) => {
  const theme = useTheme();
  const [colorHex, setColorHex] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [businessPhone, setBusinessPhone] = useState("");
  const [customerServiceContact, setCustomerServiceContact] = useState("");
  const [customerServicePhone, setCustomerServicePhone] = useState("");
  const [notificationEmail, setNotificationEmail] = useState("");
  const [orderEmail, setOrderEmail] = useState("");
  const [orderSmsNumber, setOrderSmsNumber] = useState("");
  const [stripeAccountId, setStripeAccountId] = useState("");
  const [termsUrl, setTermsUrl] = useState("");
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState("");
  const [crmApiKey, setCrmApiKey] = useState("");
  const [logo, setLogo] = useState("");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const email = localStorage.getItem("email");
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [editableField, setEditableField] = useState<string | null>(null);
  const [logoFileName, setLogoFileName] = useState<string | null>(null);
  const [errorBusinessPhone, setErrorBusinessPhone] = useState("");
  const [errorCustomerServicePhone, setErrorCustomerServicePhone] =
    useState("");
  const [errorOrderSmsNumber, setErrorOrderSmsNumber] = useState("");
  const [errorNotificationEmail, setErrorNotificationEmail] = useState("");
  const [errorOrderEmail, setErrorOrderEmail] = useState("");
  const [errorCustomerServiceContact, setErrorCustomerServiceContact] =
    useState<string>("");
  const [day, setDay] = useState(null);
  const [carrierCanonicalId, setCarrierCanonicalId] = useState("");
  const today = new Date();
  const [smartMovingKey, setSmartMovingKey] = useState("");

  // Create date-only strings for comparison (YYYY-MM-DD)

  const todayStr = today.toISOString().split("T")[0];
  const navigate = useNavigate();

  const isValidColor = (color: string): boolean => {
    const colorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    return colorRegex.test(color);
  };

  const validatePhoneNumber = (phone: string): boolean => {
    return phone === "" || /^\d{10}$/.test(phone);
  };
  const crmApiKeyRegex =
    /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$/;
  const validateEmail = (email: string): boolean => {
    return email === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validateForm = (): boolean => {
    let isValid = true;

    if (!validatePhoneNumber(businessPhone)) {
      setErrorBusinessPhone("Phone must be exactly 10 digits");
      isValid = false;
    }

    if (!validatePhoneNumber(customerServicePhone)) {
      setErrorCustomerServicePhone("Phone must be exactly 10 digits");
      isValid = false;
    }

    if (!validatePhoneNumber(orderSmsNumber)) {
      setErrorOrderSmsNumber("Phone must be exactly 10 digits");
      isValid = false;
    }

    if (!validateEmail(notificationEmail)) {
      setErrorNotificationEmail("Please enter a valid email");
      isValid = false;
    }

    if (!validateEmail(orderEmail)) {
      setErrorOrderEmail("Please enter a valid email");
      isValid = false;
    }
    if (!validatePhoneNumber(customerServiceContact)) {
      setCustomerServiceContact("Phone must be exactly 10 digits");
      isValid = false;
    }

    return isValid;
  };
  const [subscriptionPayments, setSubscriptionPayments] = useState<any>([]);
  const [carrier, setCarrier] = useState<any>(null);
  useEffect(() => {
    setIsLoading(true);
    setLoadingMessage("Loading Information...");
    if (email) {
      dispatch<any>(getCarrier(email))
        .then(unwrapResult)
        .then((res: any) => {
          const id = res.id;
          localStorage.setItem("CarrierId", id);
          setCarrier(res);
          setColorHex(res.color_hex || "");
          setBusinessName(res.business_name || "");
          setBusinessAddress(res.business_address || "");
          setBusinessPhone(res.business_phone || "");
          setCustomerServiceContact(res.customer_service_contact || "");
          setCustomerServicePhone(res.customer_service_phone || "");
          setNotificationEmail(res.notification_email || "");
          setOrderEmail(res.order_email || "");
          setOrderSmsNumber(res.order_sms_number || "");
          setStripeAccountId(res.stripe_account_id || "");
          setTermsUrl(res.terms_url || "");
          setPrivacyPolicyUrl(res.privacy_policy_url || "");
          setCrmApiKey(res.crm_api_key || "");
          setLogo(res.logo_url || "");
          setSubscriptionPayments(res.subscription_payments);
          setWebUrl(
            `${process.env.REACT_APP_URL}/${res.business_name}/${res.canonical_id}/select-service`
          );
          setDay(res.cancellation_period);
          setCarrierCanonicalId(res.canonical_id);
          setSmartMovingKey(res.smart_moving_key || "");
          setTimeout(() => {
            setIsLoading(false);
            setLoadingMessage("");
          }, 500);
        })
        .catch((err: any) => {
          setLoadingMessage("Failed to fetch carrier data.");
          setIsLoading(false);
        });
    } else {
      setLoadingMessage("Email not found.");
      setIsLoading(false);
    }
  }, [email, dispatch]);

  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [successMessage, setSuccessMessage] = useState("");
  const handleSubmit = async () => {
    if (!validateForm()) {
      setLoadingMessage("Please fix the errors before submitting.");
      return;
    }
    const formattedBusinessName = businessName
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]/g, "");

    const carrierData = {
      color_hex: colorHex,
      business_name: formattedBusinessName,
      business_address: businessAddress,
      business_phone: businessPhone,
      customer_service_contact: customerServiceContact,
      customer_service_phone: customerServicePhone,
      notification_email: notificationEmail,
      order_email: orderEmail,
      order_sms_number: orderSmsNumber,
      stripe_account_id: stripeAccountId,
      terms_url: termsUrl,
      privacy_policy_url: privacyPolicyUrl,
      crm_api_key: crmApiKey,
      email: email,
      cancellation_period: days,
      smart_moving_key: smartMovingKey,
    };

    setIsLoading(true);
    setError("");
    setLoadingMessage("Saving changes. Please wait...");

    try {
      const response = await dispatch<any>(createCarrier(carrierData));
      const result = unwrapResult(response);

      if (colorHex && isValidColor(colorHex)) {
        dispatch(
          setTheme({ primaryColor: colorHex, secondaryColor: "#4A90E2" })
        );
      }

      localStorage.setItem("businessName", formattedBusinessName);
      navigate(`/${formattedBusinessName}/dashboard`, { replace: true });
      localStorage.setItem("logo_url", logo);

      setLoadingMessage("Changes saved successfully!");
      setSuccessMessage("Changes saved successfully!");
      setState({ ...state, open: true });
      setEditableField(null);
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    } catch (err: any) {
      setIsLoading(false);
      setError(err);
      setState({ ...state, open: true });
      setLoadingMessage("Failed to save changes.");
    }

    if (logoFile) {
      const formData = new FormData();
      formData.append("file", logoFile);
      formData.append("email", email || "");

      setIsLoading(true);
      setLoadingMessage("Uploading logo. Please wait...");

      try {
        const response = await dispatch<any>(sendLogo(formData));
        const result = unwrapResult(response);
        setLogo(result.logoUrl);
        setLoadingMessage("Logo uploaded successfully!");
      } catch (error) {
        setError("Failed to upload logo. Please try again.");
        setLoadingMessage("Failed to upload logo.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setLogoFile(event.target.files[0]);
      setLogoFileName(event.target.files[0].name);
    }
  };

  const [state, setState] = React.useState({
    open: false,
    vertical: "top" as "top" | "bottom", // Explicitly set type for vertical
    horizontal: "right" as "left" | "center" | "right", // Explicitly set type for horizontal
  });

  const { vertical, horizontal, open } = state;
  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const [copied, setCopied] = useState(false);
  const [webUrl, setWebUrl] = useState("");

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(webUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const compareMonth = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentMonthPayments = carrier.subscription_payments.filter(
      (payment: any) => {
        const createdAt = new Date(payment.created_at); // Convert created_at to Date object
        const paymentMonth = createdAt.getMonth(); // Get the month of the payment's created_at (0-based)

        return currentMonth === paymentMonth; // Compare the months
      }
    );
    if (currentMonthPayments.length !== 0) {
      return true;
    } else {
      return false;
    }
  };
  const [days, setDays] = useState<number | "">("");

  const handleChange = (event: SelectChangeEvent<number>) => {
    setDays(Number(event.target.value));
  };
  function hasRecentBookingPayment(days = 30): boolean {
    const payments = carrier?.subscription_payments || [];
    if (payments.length === 0) return false;

    const cutoff = new Date(Date.now() - days * 24 * 60 * 60 * 1000);
    return payments.some(
      (payment: any) =>
        payment.is_booking_tool_included === true &&
        new Date(payment.checkout_time) > cutoff
    );
  }
  const handleCreateStripeAccount = () => {
    setIsLoading(true);
    setLoadingMessage("Stripe Onboarding in progress...");
    dispatch<any>(createStripeConnectAccount(carrier.id))
      .then(unwrapResult)
      .then((res: any) => {
        if (res.url) {
          window.location.href = res.url;
          // setIsLoading(false);
          // setLoadingMessage("");
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
  const handleCRMKeyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCrmApiKey(value);

    // Validate the format
    if (!crmApiKeyRegex.test(value)) {
      setError(
        "Please enter a valid CRM API key in the format: a2b42c7e-31g2-4a3c-8460-ac162304aa39"
      );
    } else {
      setError(""); // Clear error if format is valid
    }
    if (value === "") {
      setError("");
    }
  };
  return (
    <Box sx={{ p: 3 }}>
      {isLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
          onClick={() => {
            setIsLoading(true);
          }}
        >
          <Box sx={{ width: "50%" }}>
            <LinearProgress />
            <Typography
              fontSize={16}
              fontWeight={500}
              textAlign="center"
              mt={1}
            >
              {loadingMessage}
            </Typography>
          </Box>
        </Backdrop>
      )}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: isMobile ? "1.2rem" : "2rem",
            color: theme.palette.text.secondary,
            textAlign: "center",
          }}
        >
          CARRIER INFORMATION
        </Typography>
        {logo && (
          <Avatar
            src={logo}
            alt="Carrier Logo"
            sx={{ width: 80, height: 80 }}
          />
        )}
      </Box>
      {carrier?.stripe_account_id === null && hasRecentBookingPayment() && (
        <Stack alignItems={"center"}>
          <Typography sx={{ mb: 1, color: theme.palette.text.secondary }}>
            Please complete your stripe onboarding!
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              handleCreateStripeAccount();
            }}
            sx={{
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: "0 6px 15px rgba(0,0,0,0.3)",
              },
            }}
          >
            <Stack alignItems={"center"} spacing={1} direction={"row"}>
              <PaymentIcon />
              <Typography fontSize={isMobile ? 12 : 16}>
                Start Stripe Onboarding
              </Typography>
            </Stack>
          </Button>
        </Stack>
      )}
      {carrier?.stripe_onboarded === false &&
      carrier.stripe_account_id !== null &&
      hasRecentBookingPayment() ? (
        <StripeOnboarding
          carrier={carrier}
          setLoading={setIsLoading}
          setLoadingMessage={setLoadingMessage}
        />
      ) : null}
      {hasRecentBookingPayment() === false && (
        <Stack alignItems={"center"} alignSelf={"center"} my={5}>
          <Typography
            sx={{
              color: theme.palette.text.secondary,
              textAlign: "center",
              mb: 1,
              fontSize: 14,
            }}
          >
            PLEASE GO TO BILLING SECTION TO ACTIVATE YOUR SUBSCRIPTION.
          </Typography>
          <Button
            onClick={() => {
              setActiveComponent("Billing");
            }}
            variant="contained"
            color="primary"
            sx={{ px: 2, py: 1 }}
          >
            BILLING
          </Button>
        </Stack>
      )}

      <Typography textAlign={"center"} my={2} color="#555">
        Once you complete your stripe onboarding and activate your subscription,
        your URL will be displayed.
      </Typography>
      {carrier?.isActivated &&
      carrier?.stripe_onboarded &&
      hasRecentBookingPayment() ? (
        <Stack>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
            URL
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column", // Stack elements vertically
              gap: 3,
              width: "100%", // Make sure the box takes full width
              margin: "0 auto", // Center the box within its parent container
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center", // Align the input and the button along the center
                gap: 2, // Space between input and button
                width: "100%",
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                value={`${process.env.REACT_APP_URL}/${businessName}/${carrierCanonicalId}/select-service`}
                disabled={true}
                InputProps={{
                  startAdornment: (
                    <LinkIcon
                      sx={{ mr: 1, color: theme.palette.primary.main }}
                    />
                  ),
                }}
              />
              <Tooltip
                title={copied ? "URL copied" : ""}
                open={copied}
                disableInteractive
                arrow
              >
                <Button
                  variant="outlined"
                  color="primary"
                  size="medium"
                  onClick={handleCopyUrl}
                  sx={{ ml: 2 }}
                >
                  <ContentCopyIcon fontSize="large" />
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </Stack>
      ) : null}
      {hasRecentBookingPayment() ? (
        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
            Branding
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 3,
            }}
          >
            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #ccc",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <label>
                <input
                  id="logo-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  style={{ display: "none", cursor: "pointer" }}
                />
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <CloudUpload
                    sx={{
                      fontSize: 40,
                      color: "#4A90E2",
                      cursor: "pointer",
                      mr: 1,
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#4A90E2",
                      cursor: "pointer",
                      pt: "5px",
                    }}
                  >
                    Upload Logo
                  </Typography>
                </Box>
              </label>
              {logoFileName && (
                <Typography
                  sx={{
                    fontSize: 12,
                    color: "#666",
                    mt: 1,
                    pl: 2,
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {logoFileName.length > 30
                    ? `${logoFileName.substring(0, 27)}...`
                    : logoFileName}
                </Typography>
              )}
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Color Hex"
                variant="outlined"
                value={colorHex}
                onChange={(e) => setColorHex(e.target.value)}
                disabled={editableField !== "colorHex"}
                InputProps={{
                  startAdornment: (
                    <Palette
                      sx={{ mr: 1, color: theme.palette.primary.main }}
                    />
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("colorHex")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
              {editableField === "colorHex" && (
                <input
                  type="color"
                  value={colorHex ? colorHex : ""}
                  onChange={(e) => {
                    setColorHex(e.target.value);
                  }}
                  style={{
                    width: "50px",
                    height: "50px",
                    border: "none",
                    cursor: "pointer",
                  }}
                />
              )}
            </Box>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: "bold", mt: 4, mb: 2 }}>
            Basic Information
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 3,
            }}
          >
            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Business Name"
                variant="outlined"
                value={businessName}
                onChange={(e) => setBusinessName(e.target.value)}
                disabled={editableField !== "businessName"}
                InputProps={{
                  startAdornment: (
                    <Business
                      sx={{ mr: 1, color: theme.palette.primary.main }}
                    />
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("businessName")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Business Address"
                variant="outlined"
                value={businessAddress}
                onChange={(e) => setBusinessAddress(e.target.value)}
                disabled={editableField !== "businessAddress"}
                InputProps={{
                  startAdornment: (
                    <LocationOn
                      sx={{ mr: 1, color: theme.palette.primary.main }}
                    />
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("businessAddress")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Business Phone"
                variant="outlined"
                value={businessPhone}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setBusinessPhone(value);
                  setErrorBusinessPhone(
                    validatePhoneNumber(value)
                      ? ""
                      : "Phone must be exactly 10 digits"
                  );
                }}
                error={!!errorBusinessPhone}
                helperText={errorBusinessPhone}
                disabled={editableField !== "businessPhone"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone
                        sx={{ mr: 1, color: theme.palette.primary.main }}
                      />{" "}
                      +1
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("businessPhone")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Customer Service Contact"
                variant="outlined"
                value={customerServiceContact}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setCustomerServiceContact(value);
                  setErrorCustomerServiceContact(
                    validatePhoneNumber(value)
                      ? ""
                      : "Phone must be exactly 10 digits"
                  );
                }}
                error={!!errorCustomerServiceContact}
                helperText={errorCustomerServiceContact}
                disabled={editableField !== "customerServiceContact"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person
                        sx={{ mr: 1, color: theme.palette.primary.main }}
                      />{" "}
                      +1
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("customerServiceContact")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Customer Service Phone"
                variant="outlined"
                value={customerServicePhone}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setCustomerServicePhone(value);
                  setErrorCustomerServicePhone(
                    validatePhoneNumber(value)
                      ? ""
                      : "Phone must be exactly 10 digits"
                  );
                }}
                error={!!errorCustomerServicePhone}
                helperText={errorCustomerServicePhone}
                disabled={editableField !== "customerServicePhone"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone
                        sx={{ mr: 1, color: theme.palette.primary.main }}
                      />{" "}
                      +1
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("customerServicePhone")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Notification Email"
                variant="outlined"
                value={notificationEmail}
                onChange={(e) => {
                  setNotificationEmail(e.target.value);
                  setErrorNotificationEmail(
                    validateEmail(e.target.value)
                      ? ""
                      : "Please enter a valid email"
                  );
                }}
                error={!!errorNotificationEmail}
                helperText={errorNotificationEmail}
                disabled={editableField !== "notificationEmail"}
                InputProps={{
                  startAdornment: (
                    <Email sx={{ mr: 1, color: theme.palette.primary.main }} />
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("notificationEmail")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Order Email"
                variant="outlined"
                value={orderEmail}
                onChange={(e) => {
                  setOrderEmail(e.target.value);
                  setErrorOrderEmail(
                    validateEmail(e.target.value)
                      ? ""
                      : "Please enter a valid email"
                  );
                }}
                error={!!errorOrderEmail}
                helperText={errorOrderEmail}
                disabled={editableField !== "orderEmail"}
                InputProps={{
                  startAdornment: (
                    <Email sx={{ mr: 1, color: theme.palette.primary.main }} />
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("orderEmail")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Order SMS Number"
                variant="outlined"
                value={orderSmsNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setOrderSmsNumber(value);
                  setErrorOrderSmsNumber(
                    validatePhoneNumber(value)
                      ? ""
                      : "Phone must be exactly 10 digits"
                  );
                }}
                error={!!errorOrderSmsNumber}
                helperText={errorOrderSmsNumber}
                disabled={editableField !== "orderSmsNumber"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Message
                        sx={{ mr: 1, color: theme.palette.primary.main }}
                      />{" "}
                      +1
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("orderSmsNumber")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Stripe Account ID"
                variant="outlined"
                value={stripeAccountId}
                // onChange={(e) => setStripeAccountId(e.target.value)}
                disabled={true}
                InputProps={{
                  startAdornment: (
                    <CreditCard
                      sx={{ mr: 1, color: theme.palette.primary.main }}
                    />
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Terms URL"
                variant="outlined"
                value={termsUrl}
                onChange={(e) => setTermsUrl(e.target.value)}
                disabled={editableField !== "termsUrl"}
                InputProps={{
                  startAdornment: (
                    <Description
                      sx={{ mr: 1, color: theme.palette.primary.main }}
                    />
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("termsUrl")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="Privacy Policy URL"
                variant="outlined"
                value={privacyPolicyUrl}
                onChange={(e) => setPrivacyPolicyUrl(e.target.value)}
                disabled={editableField !== "privacyPolicyUrl"}
                InputProps={{
                  startAdornment: (
                    <Description
                      sx={{ mr: 1, color: theme.palette.primary.main }}
                    />
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("privacyPolicyUrl")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                label="CRM API Key"
                variant="outlined"
                value={crmApiKey}
                onChange={handleCRMKeyChange}
                disabled={editableField !== "crmApiKey"}
                InputProps={{
                  startAdornment: (
                    <Lock sx={{ mr: 1, color: theme.palette.primary.main }} />
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("crmApiKey")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
                helperText={"Format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"}
                error={!!error} // Show error style if there's an error
              />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                position: "relative",
                mb: isMobile ? 2 : 3,
                display: "flex",
              }}
            >
              <TextField
                fullWidth
                label="Smart Moving Key"
                variant="outlined"
                value={smartMovingKey}
                onChange={(e) => setSmartMovingKey(e.target.value)}
                disabled={editableField !== "smartMovingKey"}
                InputProps={{
                  startAdornment: (
                    <Lock sx={{ mr: 1, color: theme.palette.primary.main }} />
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setEditableField("smartMovingKey")}
                      sx={{ ml: 1 }}
                    >
                      <Edit />
                    </IconButton>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                flex: "1 1 45%",
                minWidth: "240px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box sx={{ flexGrow: 1, position: "relative" }}>
                <Typography
                  variant={isMobile ? "body2" : "body1"}
                  gutterBottom
                  sx={{
                    fontSize: isMobile ? "0.875rem" : "1rem",
                    fontWeight: 500,
                    lineHeight: 1.5,
                  }}
                >
                  How many days in advance can customers cancel their move
                  without penalty?
                </Typography>

                <FormControl fullWidth>
                  <InputLabel id="cancel-days-label">
                    {day || "Days"}
                  </InputLabel>
                  <Select
                    labelId="cancel-days-label"
                    value={days || ""}
                    label="Days"
                    onChange={handleChange}
                    disabled={editableField !== "cancellationDays"}
                  >
                    {[...Array(15)].map((_, idx) => (
                      <MenuItem key={idx + 1} value={idx + 1}>
                        {idx + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <IconButton
                onClick={() =>
                  setEditableField(
                    editableField === "cancellationDays"
                      ? null
                      : "cancellationDays"
                  )
                }
                sx={{ ml: 1, alignSelf: "flex-end", mt: "22px" }}
              >
                <Edit />
              </IconButton>
            </Box>
          </Box>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            onClose={handleClose}
            autoHideDuration={4000} // Close after 4 seconds
            key={vertical + horizontal}
          >
            <Alert
              onClose={handleClose}
              severity={error ? "error" : "success"}
              sx={{ width: "100%" }}
            >
              {error ? error : successMessage ? successMessage : ""}
            </Alert>
          </Snackbar>
          {error && (
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>
          )}
          <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{ px: 4, py: 2, width: isMobile ? "100%" : "200px" }}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};

export default CarrierInfo;
